// apps/web/src/lib/apiBase.ts
export const API_BASE =
  (import.meta as any).env?.VITE_API_BASE ||
  (typeof window !== 'undefined' && (window as any).__API_BASE) ||
  'http://192.168.200.180:3001'; // local fallback for dev/LAN
